var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.0425 99.7525H56.94C51.265 99.7525 46.65 95.1375 46.65 89.465V85.91C46.53 80.2125 45.3125 78.3825 42.5675 74.265C41.6325 72.8625 40.575 71.275 39.3775 69.2575C37.17 65.545 36.0025 61.305 36.0025 56.9975C36.0025 43.765 46.7675 33 60.0025 33C73.2375 33 84.0025 43.765 84.0025 56.9975C84.0025 61.305 82.835 65.5475 80.6275 69.26C79.0375 71.93 77.6475 73.4675 76.53 74.705C74.8925 76.515 74.1475 77.3425 73.685 81.115C73.4525 83.0275 73.335 84.9675 73.335 86.8825V89.4675C73.335 95.14 68.7175 99.755 63.045 99.755L63.0425 99.7525ZM52.6575 89.755C52.8075 91.985 54.67 93.7525 56.9375 93.7525H63.04C65.405 93.7525 67.33 91.83 67.33 89.465V86.88C67.33 84.7225 67.4625 82.5375 67.725 80.385C68.37 75.1075 69.7975 73.1975 72.0725 70.6775C73.06 69.585 74.18 68.345 75.465 66.1875C77.12 63.4025 77.9975 60.2225 77.9975 56.9925C77.9975 47.07 69.9225 38.995 59.9975 38.995C50.0725 38.995 41.9975 47.0675 41.9975 56.9925C41.9975 60.2225 42.8725 63.4025 44.53 66.19C45.6475 68.075 46.66 69.5925 47.555 70.935C50.625 75.5425 52.655 78.5875 52.655 86.88V89.755H52.6575Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 105C55.0375 105 51 100.963 51 96H57C57 97.655 58.345 99 60 99C61.655 99 63 97.655 63 96H69C69 100.963 64.9625 105 60 105Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63 15H57V27H63V15Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5974 19.1268L36.4012 22.1268L42.3987 32.5148L47.5949 29.5148L41.5974 19.1268Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1263 33.4031L22.1263 38.5992L32.5143 44.5967L35.5143 39.4006L25.1263 33.4031Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30 54H18V60H30V54Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5128 69.4051L22.1249 75.4026L25.1249 80.5987L35.5128 74.6012L32.5128 69.4051Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4854 69.404L84.4854 74.6001L94.8734 80.5976L97.8734 75.4015L87.4854 69.404Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102 54H90V60H102V54Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8735 33.4044L84.4855 39.4019L87.4855 44.5981L97.8735 38.6006L94.8735 33.4044Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3989 19.1285L72.4015 29.5165L77.5976 32.5165L83.5951 22.1285L78.3989 19.1285Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/FAQ.a426700a.svg";
export { ForwardRef as ReactComponent };